import type { AnySchema } from 'joi';

import { SchemaField } from '../../../../../objects/generic/serialization/schema-field';
import { EventType } from '../../../../../objects/org/event-type/event-type';
import { UserRequestSchema } from '../../generic/user-request/user-request-schema';

export class UserRequestCreateOrgSchema extends UserRequestSchema {
  public static readonly orgId = 'orgId';

  public static readonly displayName = 'displayName';

  public static readonly timezone = 'timezone';

  public static readonly e164Phones = 'e164Phones';

  public static readonly eventTypes = 'eventTypes';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Default Values to serialize
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Definition
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: AnySchema } {
    const parameters = super.getSchemaDefinition();

    parameters[UserRequestCreateOrgSchema.orgId] = SchemaField.string(undefined).required();
    parameters[UserRequestCreateOrgSchema.displayName] = SchemaField.string(undefined).required();
    parameters[UserRequestCreateOrgSchema.timezone] = SchemaField.string(undefined).required();
    parameters[UserRequestCreateOrgSchema.e164Phones] = SchemaField.shortStringArray(undefined).required();
    parameters[UserRequestCreateOrgSchema.eventTypes] = SchemaField.shortObjArray(EventType, undefined).required();

    return parameters;
  }
}
